import {addClass, removeClass, toggleClass} from "./_vars";
import {disableScroll} from "./functions/disableScroll.js";
import _dom from "./functions/dom.js";
import {enableScroll} from "./functions/enableScroll.js";

const accordions = document.querySelectorAll(".accordion");
accordions.forEach((accordion, index) => {
   accordion.addEventListener("click", () => {
      toggleClass(accordion, "--show");
      const accordionBody = accordion.querySelector(".accordion__body");
      if (accordionBody.style.maxHeight) {
         accordionBody.style.maxHeight = null;
      } else {
         accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
      }
   });
});

const getDomainWithoutSubdomain = url => {
   const urlParts = new URL(url).hostname.split('.')

   return urlParts
      .slice(0)
      .slice(-(urlParts.length === 4 ? 3 : 2))
      .join('.')
}
const cookieBlock = document.querySelector(".cookie");
addEventListener("load", () => {
   const isCookie = document.cookie.replace(/(?:(?:^|.*;\s*)cookie\s*=\s*([^;]*).*$)|^.*$/, "$1");
   if (!isCookie) removeClass(cookieBlock, "--hidden")
})
addEventListener("click", (e) => {
   if (!e.target.closest(".cookie__button")) return;

   addClass(cookieBlock, "--hidden")
   document.cookie = `cookie=true;path=/;domain=${getDomainWithoutSubdomain(location.href)};max-age=${60 * 60 * 24 * 365}`;
})

const btn = document.querySelector(".menu__link_services");
addEventListener("click", (e) => {
   let button = e.target.closest(".menu__link_services");
   if (document.body.classList.contains("--active-services-items")) button = !e.target.closest(".services-items");
   if (!button) return;

   const isAdded = toggleClass(btn, "--active");
   toggleClass(document.body, "--active-services-items")
   isAdded ? disableScroll() : enableScroll();
});

import IMask from "imask";
const elementsInputMask = document.querySelectorAll(".input-mask");
[...elementsInputMask].forEach(el => {
   if (!el._imask_) el._imask_ = {};
   el._imask_.instance = IMask(el, {
      mask: "+0 (000) 000-00-00"
   });
   let isFakeEvent;
   const setCursor = () => el.selectionStart = el.selectionEnd = el.value.length;
   el._imask_.instance.on("accept", e => {
      el._imask_.isValid = false;
      el.setCustomValidity("Заполните поле.");

      if (isFakeEvent) return isFakeEvent = false;

      if (el._imask_.instance._unmaskedValue.length === 1 && (e.data === "8" || e.data === "7")) {
         isFakeEvent = true;
         el._imask_.instance.value = "7";
      } else if (el._imask_.instance._unmaskedValue.length === 1 && (e.data !== "8" || e.data !== "7")) {
         isFakeEvent = true;
         el._imask_.instance.value = "7" + e.data;
         setTimeout(setCursor, 15);
         setTimeout(setCursor, 100);
      }
      if (!el._imask_.instance.value.includes("+7")) {
         isFakeEvent = true;
         el._imask_.instance.value = "7" + el._imask_.instance.value.slice(2);
         setTimeout(setCursor, 15);
         setTimeout(setCursor, 100);
      }
   });
   el._imask_.instance.on("complete", () => {
      el._imask_.isValid = true;
      el.setCustomValidity("");
   });
});
addEventListener("invalid", ({target}) => {
   const form = target.closest("form");
   if (!form || form.classList.contains("--invalid")) return;

   addClass(form, "--invalid");
}, true);
addEventListener("submit", ({target}) => {
   const form = target.closest("form");
   if (!form || !form.classList.contains("--invalid")) return;

   removeClass(form, "--invalid");
   alert('отправка')
}, true);
addEventListener("change", ({target}) => {
   const form = target.closest("form");
   if (!form || !form.classList.contains("--invalid")) return;

   const isValid = target?.validity?.valid;
   if (isValid) removeClass(form, "--invalid");
}, true);

const fileButton = document.querySelector(".file-button");
if (fileButton) {
   const input = fileButton.firstElementChild;
   const textSpan = fileButton.lastElementChild;
   let initialText = textSpan.textContent;
   fileButton.addEventListener("click", (e) => {
      input.value = "";
      textSpan.textContent = initialText;
      removeClass(fileButton, "file-button_active");
   })
   fileButton.addEventListener("change", (e) => {
      textSpan.textContent = input.files[0].name;
      addClass(fileButton, "file-button_active");
   })
}
const avatarFile = document.querySelector(".form-photo__file");
if (avatarFile) {
   const radio = document.querySelector("#form-photo__option-3");
   const preview = document.querySelector(".form-photo__option_file");
   class UploadImage {
      static #wasInit;
      static #init() {
         if (this.#wasInit) return;
         this.#wasInit = true;

         addEventListener("change", async e => {
            const target = e.target.closest(".form-photo__file");
            if (!target?.files[0]) return radio.checked = false;

            const local = target._app_.uploadImage;
            await local.#uploadFile(0);
         });
      }
      /**
       * Загрузка файла
       * @async
       * @param {number} fileIndex Index Файла
       */
      async #uploadFile(fileIndex) {
         const file = this.el.files[fileIndex];

         if (!["image/jpeg", "image/png", "image/gif"].includes(file.type)) { // Проверяем тип файла
            alert("Неверный формат фото");
            this.el.value = "";
            return;
         }

         if (file.size > 2_097_152) return alert("Файл должен быть меньше 2MB", "error"); // Проверим размер файла (<2 Мб)

         const reader = new FileReader();
         reader.onload = e => {
            if (this.preview) this.preview.innerHTML = `<img src="${e.target.result}" alt="">`;
            radio.checked = true;
         };
         reader.onerror = () => alert('Ошибка');
         reader.readAsDataURL(file);
      }
      clear() {
         this.preview.innerHTML = "<img src='/wp-content/themes/business/img/avatar-custom.webp'>";
         this.el.value = "";
      }
      /**
       * Создает Элемент `UploadImage`
       * @param {Element} el Элемент `UploadImage`
       * @property {Element} el Элемент `UploadImage`
       * @property {Element} preview Элемент `UploadImage Preview`
       */
      constructor(el) {
         el._app_ ??= {};
         el._app_.uploadImage = this;

         this.el = el;
         this.preview = preview;

         UploadImage.#init();
      }
   }
   const uploadImage = new UploadImage(avatarFile);
   addEventListener("click", (e) => {
      const button = e.target.closest(".form-photo__option_file");
      if (!button) return;

      uploadImage.clear();
      radio.checked = false
      avatarFile.click();
   })

   // const dataPlaceholder = document.querySelectorAll("[data-placeholder]");
   // [...dataPlaceholder].forEach(input => {
   //    input.value = input.dataset.placeholder;
   // });
   // addEventListener("focusin", e => {
   //    if (!e.target?.hasAttribute("data-placeholder")) return;

   //    const placeholder = e.target.dataset?.placeholder;
   //    if (!placeholder) return;

   //    if (e.target.value === placeholder || !e.target.value) e.target.value = "";
   // })
   // addEventListener("focusout", e => {
   //    if (!e.target?.hasAttribute("data-placeholder")) return;

   //    const placeholder = e.target.dataset?.placeholder;
   //    if (!placeholder) return;

   //    if (e.target.value === placeholder || !e.target.value) e.target.value = placeholder;
   // })
}

/**
 * Класс представляющий Rating
 * @class
 */
class Rating {
   /** Префикс для имени события */
   static #eventPrefix = "_app_.rating.";
   /** Объект с полными названиями событий */
   static events = {
      onChange: this.#eventPrefix + "onChange",
   };
   /** Объект с экземплярами событий */
   static #events = {
      /** Вызывается после любого изменения в `Rating` */
      onChange: new Event(this.events.onChange, {bubbles: true, cancelable: true}),
   };
   static #wasInit;
   static #initialize() {
      if (this.#wasInit) return;
      this.#wasInit = true;

      addEventListener("mouseup", async e => await this.#setOnEvent(e));
      addEventListener("keyup", async e => e.code === "Space" && await this.#setOnEvent(e));
   }
   /**
    * Установка rating при событии
    * @async
    * @param {Event} e Событие
    */
   static async #setOnEvent(e) {
      const input = e.target.closest(".js_e-rating input");
      if (!input) return;

      const rating = input.parentElement.parentElement.parentElement;
      if (!_dom.el.has("rating-edit", rating, 3)) return;

      await rating._app_.rating.setRatingValue(input.value, rating);
   }
   /**
    * Запуск rating
    */
   #init() {
      this.#updateActive();
      if (_dom.el.has("rating-edit", this.el, 3)) {
         this.el.addEventListener("mouseover", e => this.setActive(e)); // Вход мыши в звезды
         this.el.addEventListener("focusin", e => this.setActive(e)); // Вход мыши в звезды
         this.el.addEventListener("mouseout", e => this.#updateActive(e)); // Выход мыши с звезды
         this.el.addEventListener("focusout", e => this.#updateActive(e)); // Выход мыши с звезды
      }
   }
   /**
    * Установка ширины
    * @param {(Event|boolean)} [e=false] Событие (для делегации) [false]
    * @param {string} i Индекс\Значение Звезды
    */
   #updateActive(e = false, i = this.valueEl.innerHTML) {
      if (e && !e.target.closest(".js_e-rating input")) return;

      this.activeEl.style.width = `${i / 0.05}%`;
   }
   /**
    * Установить `active` ровняющейся input
    * @param {Event} e Событие
    */
   setActive(e) {
      const ratingItem = e.target.closest(".js_e-rating input");
      if (!ratingItem) return;

      this.#updateActive(false, ratingItem.value);
   }
   /**
    * Отправка
    * @async
    * @param {string} value Значение
    */
   async setRatingValue(value) {
      this.valueEl.innerHTML = value; // Установка нового значения
      this.#updateActive();
      this.el.dispatchEvent(Rating.#events.onChange);
   }
   /**
    * Создает Элемент `Rating`
    * @param {Element} el Элемент `Rating`
    * @property {Element} el Элемент `Rating`
    * @property {Element} activeEl Элемент `activeEl Rating`
    * @property {Element} valueEl Элемент `valueEl Rating`
    */
   constructor(el) {
      el._app_ ??= {};
      el._app_.rating = this;

      this.el = el;
      this.activeEl = el.firstElementChild.firstElementChild.nextElementSibling;
      this.valueEl = el.lastElementChild;
      this.#init();

      Rating.#initialize();
   }
}
const ratings = document.querySelectorAll(".js_e-rating");
ratings.forEach(rating => {
   new Rating(rating)
});
const reviewsParent = document.querySelector(".reviews__inner");
if (reviewsParent) {
   function initRatings() {
      const ratings = reviewsParent.querySelectorAll(".js_e-rating");
      ratings.forEach(rating => {
         new Rating(rating)
      });
   }
   function handleMutations(mutationsList, observer) {
      mutationsList.forEach((mutation) => {
         if (mutation.type === 'childList') initRatings();
      });
   }
   const observer = new MutationObserver(handleMutations);
   observer.observe(reviewsParent, {childList: true});
}

import VenoBox from "venobox";
new VenoBox({
   selector: ".js_e-gallery",
   infinigall: true,
});

/**
 * Класс представляющий Tabs
 * @class
 */
class Tabs {
   /** Префикс для имени события */
   static #eventPrefix = "_app_.tabs.";
   /** Объект с полными названиями событий */
   static events = {
      onChange: this.#eventPrefix + "onChange",
   };
   /** Объект с экземплярами событий */
   static #events = {
      /** Вызывается после любого изменения в Tabs */
      onChange: new Event(this.events.onChange, {bubbles: true, cancelable: true}),
   };
   /**
    * Открыть заданную вкладку
    * @private
    * @param {number} i Индекс вкладки
    */
   #openTab(i) {
      _dom.el.add("act-tab", this.buttons[i]);
      _dom.el.add("act-tab", this.tabs[i]);
      _dom.el.attr.set("tabs", i, this.el);
      this.activeIndex = i;
   }
   /**
    * Закрыть заданную вкладку
    * @private
    * @param {number} i Индекс вкладки
    */
   #closeTab(i) {
      _dom.el.del("act-tab", this.buttons[i]);
      _dom.el.del("act-tab", this.tabs[i]);
   }
   /**
    * Открыть заданную вкладку и закрыть предыдущую
    * @param {number} i Индекс вкладки
    */
   openTab(i) {
      if (this.activeIndex === i) return;

      this.#closeTab(this.activeIndex);
      this.#openTab(i);
      this.el.dispatchEvent(Tabs.#events.onChange);
   }
   /**
    * Создает Элемент `Tabs`
    * @param {Element} el Элемент `Tabs`
    * @property {Element} el - Элемент `Tab`
    * @property {number} activeIndex - Индекс активной вкладки
    * @property {boolean} isClasses - Флаг, указывающий, используются ли классы для определения структуры
    * @property {Element[]} buttons - Массив кнопок для вкладок
    * @property {Element[]} tabs - Массив вкладок
    */
   constructor(el) {
      el._app_ ??= {};
      el._app_.tabs = this;

      this.el = el;
      this.activeIndex = +_dom.el.attr.get("tabs", this.el);

      this.isClasses = _dom.el.has("tabs-cls", el, 3);
      if (this.isClasses) {
         const nav = _dom.get.one("tabs-nav", 1, el);
         this.buttons = [..._dom.get.all("button", 4, nav)];
         if (!this.buttons.length) this.buttons = [..._dom.get.all("tab-btn", 1, nav)];
         this.tabs = _dom.get.all("tab", 1, el);
      } else {
         const nav = el.firstElementChild;
         this.buttons = [...nav.children];
         this.tabs = nav.nextElementSibling.children;
      }
   }
}
const tabsEls = [..._dom.get.all("tabs")];
tabsEls.forEach(element => new Tabs(element));
addEventListener("click", function (e) {
   const tabsEl = e.target.closest(".js_e-tabs");
   if (!tabsEl) return;

   if (!tabsEl?._app_?.tabs) new Tabs(tabsEl);
   const tabs = tabsEl._app_.tabs;

   const button = tabs.isClasses ? (e.target.closest(".js_e-tabs .js_e-tabs-nav button") || e.target.closest(".js_e-tabs .js_e-tabs-nav .js_e-tab-btn")) : e.target.closest(".js_e-tabs>div:first-child button");
   if (!button) return; // Если клик не на tab button прекратить

   const i = tabs.buttons.indexOf(button);
   tabs.openTab(i);
});


const videoPopupVideo = document.querySelector(".video-popup__video video");
if (videoPopupVideo) {
   const videoPopupParent = videoPopupVideo.parentElement;
   const videoPopupEl = videoPopupVideo.closest("[data-modal-block]");
   const playPopup = videoPopupEl.querySelector(".video-play-clients");
   const closeButtonVideo = videoPopupEl.querySelector(".video-review__close");
   addEventListener("click", e => {
      const link = e.target.closest("[data-video]");
      if (!link) return;

      addClass(videoPopupEl, "--show");
      window.activePopup = videoPopupEl;
      disableScroll();

      const videoSrc = _dom.el.attr.get("video", link);
      const poster = _dom.el.attr.get("poster", link);
      videoPopupVideo.setAttribute("src", videoSrc);
      videoPopupVideo.setAttribute("poster", poster);

      videoPopupVideo.play();
      videoPopupVideo.addEventListener("pause", () => {
         removeClass(playPopup, "--hidden");
         removeClass(videoPopupParent, "--play");
      });
      videoPopupVideo.addEventListener("play", () => {
         addClass(playPopup, "--hidden");
         addClass(videoPopupParent, "--play");
      });

      addClass(playPopup, "--hidden");
      addClass(videoPopupParent, "--play");
   });
   playPopup.addEventListener("click", () => {
      videoPopupVideo.play();
      removeClass(playPopup, "--hidden");
      removeClass(videoPopupParent, "--play");
   })
   closeButtonVideo.addEventListener("click", () => {
      videoPopupVideo.pause();
      removeClass(playPopup, "--hidden");
      removeClass(videoPopupParent, "--play");
   })
}

addEventListener("click", e => {
   const icon = e.target.closest(".blog-card__share-icon")
   if (!icon) return;

   toggleClass(icon.parentElement, "--active");
   if (innerWidth > 767) {
      const block = document.querySelector(".paper-banner");
      block?.scrollIntoView();
   }
});
addEventListener("click", (e) => {
   const btn = e.target.closest(".city-popup__btn,.city-popup__close");
   if (!btn) return;

   document.querySelector(".city-popup").classList.add("--hidden");
   if (btn.matches(".city-popup__close")) localStorage.setItem("cityWindow", "true");
})
if (localStorage.getItem("cityWindow")) addEventListener("DOMContentLoaded", () => {
   const geoWindow = document.querySelector(".city-popup");
   if (!geoWindow) return;

   geoWindow.classList.add("--hidden");
})
const geoPopup = document.getElementById("modal-city");
addEventListener("click", (e) => {
   const btn = e.target.closest("#geolocationChangeCity, .geolocation__link");
   if (!btn) return;

   addClass(geoPopup, "--show");
})

const casesTip = document.querySelector(".cases__tip")
if (casesTip) {
   const parent = document.querySelector(".cases__switchers-inner");
   const MARGIN = 8;
   function check() {
      const parentWidth = parent.clientWidth;
      let slidesWidth = 0;
      [...parent.children].forEach(element => {
         slidesWidth += element.clientWidth + MARGIN;
      });
      if (slidesWidth - MARGIN <= parentWidth) casesTip.style.display = "none";
      else casesTip.style.display = "";
   }
   check();
   function handleMutations(mutationsList, observer) {
      mutationsList.forEach((mutation) => {
         if (mutation.type === 'childList') {
            parent.style.transform = "translate3d(0px, 0px, 0px)";
            check();
         }
      });
   }
   const observer = new MutationObserver(handleMutations);
   observer.observe(parent, {childList: true});
}